import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCar, faExclamationCircle, faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";
import { faCalendarCheck, faCarGarage, faUserCheck, faWrench } from "@fortawesome/pro-solid-svg-icons";
import { DAYPLANNER_STATUSES } from ".";

const StatusFilter = ({ color, name, count, filter, onClick, disabled }) => {
  const renderIcon = () => {
    switch (filter) {
      case DAYPLANNER_STATUSES.NEW_CAR:
        return <FontAwesomeIcon icon={faCar} />;
      case DAYPLANNER_STATUSES.CAR_IN_SHOP:
        return <FontAwesomeIcon icon={faCarGarage} />;
      case DAYPLANNER_STATUSES.PANIC:
        return <FontAwesomeIcon icon={faExclamationCircle} />;
      case DAYPLANNER_STATUSES.ANNAME_OK:
        return <i className="material-icons">font_download</i>;
      case DAYPLANNER_STATUSES.HANDLE_CHECK_IN:
        return <FontAwesomeIcon icon={faCalendarCheck} />;
      case DAYPLANNER_STATUSES.CAR_CHECK:
        return <FontAwesomeIcon icon={faWrench} />;
      case DAYPLANNER_STATUSES.DIAGNOSE:
        return <FontAwesomeIcon icon={faExclamationTriangle} />;
      case DAYPLANNER_STATUSES.CUSTOMER_ANSWERED:
        return <FontAwesomeIcon icon={faUserCheck} />;
      case DAYPLANNER_STATUSES.CUSTOMER_OK:
        return <i className="material-icons">face</i>;
      case DAYPLANNER_STATUSES.BACK_ORDER:
        return (
          <div className="backorder-icon">
            <span>BO</span>
          </div>
        );
      default:
        return;
    }
  };

  const className = `status-filter ${disabled ? "disabled" : "clickable"}`;

  return (
    <div className={className} style={{ borderColor: color }} onClick={() => onClick(filter)}>
      <div style={{ backgroundColor: color }} className="status-filter-icon">
        {renderIcon()}
      </div>
      <div className="status-filter-count">{count}</div>
    </div>
  );
};

export default StatusFilter;
